module.exports = require("@splunk/themes/enterpriseDark");